import api from "../api/axios";


export const obtenerComunidades = () => {
    return api.get("/comunidad");
};


// ============================================
// OBTENER PÚBLICAS
// ============================================

export const obtenerComunidadPublica = () => {
    return api.get("/comunidad/public");
};


// ============================================
// OBTENER DESTACADOS
// ============================================

export const obtenerComunidadDestacados = () => {
    return api.get("/comunidad/destacados");
};


// ============================================
// CREAR
// ============================================

export const crearComunidad = (formData) => {
    return api.post(
        "/crear/comunidad",
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    );
};


// ============================================
// EDITAR
// ============================================

export const actualizarComunidad = (id, formData) => {

    formData.append("_method", "PUT");

    return api.post(
        `/editar/comunidad/${id}`,
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    );
};


// ============================================
// ELIMINAR
// ============================================

export const eliminarComunidad = (id) => {
    return api.delete(`/delete/comunidad/${id}`);
};